import { AiOutlineMail } from "react-icons/ai";
import { BsPerson } from "react-icons/bs";
import { FiPhone } from "react-icons/fi";
import { HiOutlineKey } from "react-icons/hi";
import { User } from "../../../interfaces/interfaces";
import styles from "./UserProfile.module.scss";

type props = {
    user: User,
    edit: Function
    allUsers: User[]
}

export default function UserProfile({ user, edit }: props) {

    // const user: User = data.filter((employee: User) => employee.name === userName)[0];
    const renderName = (name) => {
        let userNameSplit = name.split(" ");
        return `${userNameSplit[0].charAt(0)}`.toUpperCase();
    };

    return (
        <div className={styles.userProfile}>
            <div>
                <div className={styles.profilePicBlock}>
                    <div style={{ backgroundColor: user.color ? `#${user.color}` : '#596de7' }} className={`${styles.profileImage}`}>

                        {renderName(user.name)}
                    </div>
                    <div className={styles.fullName} >{user.name}</div>
                </div>
                <hr />
                <div className={styles.infoBlock}>
                    <div className={styles.userInfo}>
                        <div><BsPerson size={"1.3rem"} /></div>
                        <div className={styles.inputDiv}>{user.designation}</div>
                    </div>
                    <div className={styles.userInfo}>
                        <div> <FiPhone size={"1.3rem"} /></div>
                        <div className={styles.inputDiv}>{user.phoneNumber}</div>
                    </div>
                    <div className={styles.userInfo}>
                        <div><AiOutlineMail size={"1.3rem"} /></div>
                        <div className={styles.inputDiv}>{user.email}</div>
                    </div>
                    {/* <div className={styles.userInfo}>
                    <div> Designation:</div>
                    <div className={styles.inputDiv}> <input className={styles.designation} placeholder="Enter Designation" /></div>
                </div> */}
                    <div className={styles.userInfo}>
                        <div> <HiOutlineKey size={"1.3rem"} /> </div>
                        <div className={styles.inputDiv}>
                            {user.role}
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.btns}>
                <button
                    className={styles.editBtn}
                    onClick={() => edit()}
                >
                    Edit Profile
                </button>
            </div>
        </div>
    );
}